const PNP_REFRESH_V1 = 'GROW-2792';
const TYPE_DESCRIPTION = '[Type: String][Vis.: high] - ';
const EXPERIMENT_DESCRIPTION = ' - A string in pricing experiment GROW-2792';
const DETAILS_TABLE = 'form details table';

const experimentDetailsCopy = {
  grow_2792_survey_create_limit: {
    id: 'Pricing.experimentDetailsCopy.SurveyCreateLimit',
    defaultMessage: 'Number of forms & surveys',
    desc: {
      id: 'Pricing.experimentDetailsCopy.SurveyCreateLimit',
      message: `${TYPE_DESCRIPTION} ${DETAILS_TABLE} label ${EXPERIMENT_DESCRIPTION} (new)`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_questions_per_form_survey: {
    id: 'Pricing.experimentDetailsCopy.QuestionsPerFormSurvey',
    defaultMessage: 'Questions per form or survey',
    desc: {
      id: 'Pricing.experimentDetailsCopy.QuestionsPerFormSurvey',
      message: `${TYPE_DESCRIPTION} ${DETAILS_TABLE} label ${EXPERIMENT_DESCRIPTION} (new)`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_recurring_surveys: {
    id: 'Pricing.experimentDetailsCopy.RecurringFormsSurveys',
    defaultMessage: 'Recurring forms & surveys',
    desc: {
      id: 'Pricing.experimentDetailsCopy.RecurringFormsSurveys',
      message: `${TYPE_DESCRIPTION} ${DETAILS_TABLE} label ${EXPERIMENT_DESCRIPTION} (override)`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_skip_logic: {
    id: 'Pricing.experimentDetailsCopy.SkipLogicOnly',
    defaultMessage: 'Skip logic only',
    desc: {
      id: 'Pricing.experimentDetailsCopy.SkipLogicOnly',
      message: `${TYPE_DESCRIPTION} ${DETAILS_TABLE} label ${EXPERIMENT_DESCRIPTION} (override)`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_survey_builder: {
    id: 'Pricing.experimentDetailsCopy.FormSurveyBuilder',
    defaultMessage: 'Form & Survey Builder',
    desc: {
      id: 'Pricing.experimentDetailsCopy.FormSurveyBuilder',
      message: `${TYPE_DESCRIPTION} ${DETAILS_TABLE} heading ${EXPERIMENT_DESCRIPTION} (new)`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_database_response_view: {
    id: 'Pricing.experimentDetailsCopy.DatabaseResponseView',
    defaultMessage: 'Database response view',
    desc: {
      id: 'Pricing.experimentDetailsCopy.DatabaseResponseView',
      message: `${TYPE_DESCRIPTION} ${DETAILS_TABLE} heading ${EXPERIMENT_DESCRIPTION} (new)`,
      project: PNP_REFRESH_V1,
    },
  },
  best_worst_qt: {
    id: 'Pricing.experimentDetailsCopy.BestWorstQt',
    defaultMessage: 'Best worst scale',
    desc: {
      id: 'Pricing.experimentDetailsCopy.BestWorstQt',
      message: `${TYPE_DESCRIPTION} ${DETAILS_TABLE} heading ${EXPERIMENT_DESCRIPTION}`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_use_collectors: {
    id: 'Pricing.experimentDetailsCopy.UseCollectors',
    defaultMessage: 'Use {number} collectors per form or survey',
    desc: {
      id: 'Pricing.experimentDetailsCopy.UseCollectors',
      message: `${TYPE_DESCRIPTION} ${DETAILS_TABLE} details ${EXPERIMENT_DESCRIPTION}`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_customer_success_manager: {
    id: 'Pricing.experimentDetailsCopy.CustomerSuccessManger',
    defaultMessage: 'Customer success manager',
    desc: {
      id: 'Pricing.experimentDetailsCopy.CustomerSuccessManger',
      message: `${TYPE_DESCRIPTION} ${DETAILS_TABLE} details ${EXPERIMENT_DESCRIPTION}`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_advanced_collaboration: {
    id: 'Pricing.experimentDetailsCopy.AdvancedCollaboration',
    defaultMessage: 'Contributor seats',
    desc: {
      id: 'Pricing.experimentDetailsCopy.AdvancedCollaboration',
      message: `${TYPE_DESCRIPTION} ${DETAILS_TABLE} details ${EXPERIMENT_DESCRIPTION}`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_dashboard: {
    id: 'Pricing.experimentDetailsCopy.Dashboard',
    defaultMessage: 'Dashboard',
    desc: {
      id: 'Pricing.experimentDetailsCopy.Dashboard',
      message: `${TYPE_DESCRIPTION} ${DETAILS_TABLE} details ${EXPERIMENT_DESCRIPTION}`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_dashboard_pwd_protection: {
    id: 'Pricing.experimentDetailsCopy.DashboardPwdProtection',
    defaultMessage: 'Dashboard password protection',
    desc: {
      id: 'Pricing.experimentDetailsCopy.DashboardPwdProtection',
      message: `${TYPE_DESCRIPTION} ${DETAILS_TABLE} details ${EXPERIMENT_DESCRIPTION}`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_word_cloud_combine_hide: {
    id: 'Pricing.experimentDetailsCopy.WordCloudCombineHide',
    defaultMessage: 'Word clouds: Combine or hide words',
    desc: {
      id: 'Pricing.experimentDetailsCopy.WordCloudCombineHide',
      message: `${TYPE_DESCRIPTION} ${DETAILS_TABLE} details ${EXPERIMENT_DESCRIPTION}`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_tag_written_answers_enterprise: {
    id: 'Pricing.experimentDetailsCopy.TagWrittenAnswersEnterprise',
    defaultMessage: 'Manual & rule-based',
    desc: {
      id: 'Pricing.experimentDetailsCopy.TagWrittenAnswersEnterprise',
      message: `${TYPE_DESCRIPTION} ${DETAILS_TABLE} details ${EXPERIMENT_DESCRIPTION}`,
      project: PNP_REFRESH_V1,
    },
  },
};

export default experimentDetailsCopy;
